import keycloak from '../keycloak-init';

function parsePositiveInt(raw: unknown): number | undefined {
  if (raw == null || raw === '') return undefined;
  const n = parseInt(String(raw), 10);
  return Number.isFinite(n) && n > 0 ? n : undefined;
}

/** Nombre visible del usuario en sesión (login / Keycloak). */
export function getManufacturingBatchDisplayName(): string {
  const lsName = [localStorage.getItem('name'), localStorage.getItem('surname')]
    .filter(Boolean)
    .join(' ')
    .trim();
  const tp = keycloak.tokenParsed;
  return (
    (tp?.['name'] as string) ||
    [tp?.['given_name'], tp?.['family_name']].filter(Boolean).join(' ').trim() ||
    lsName ||
    ''
  ).trim();
}

export function getCurrentUserEmail(): string {
  return (
    (keycloak.tokenParsed?.['email'] as string) ||
    localStorage.getItem('email') ||
    ''
  ).trim();
}

/** Usuario de login (Keycloak preferred_username). */
export function getCurrentUsername(): string {
  return ((keycloak.tokenParsed?.['preferred_username'] as string) || '').trim();
}

/**
 * ID del empleado en sesión.
 * Orden: localStorage employeeId → claims Keycloak → localStorage sessionId (login legacy).
 */
export function getManufacturingBatchActorEmployeeId(): number | undefined {
  const fromStorage = parsePositiveInt(localStorage.getItem('employeeId'));
  if (fromStorage) return fromStorage;

  const tp = keycloak.tokenParsed;
  const fromToken =
    parsePositiveInt(tp?.['employeeId']) ?? parsePositiveInt(tp?.['sessionId']);
  if (fromToken) return fromToken;

  return parsePositiveInt(localStorage.getItem('sessionId'));
}

/** Resuelve empleado por email cuando no hay ID en sesión. */
export function resolveEmployeeIdByEmail(
  employees: Array<{ id: number; email?: string | null }>,
): number | undefined {
  const email = getCurrentUserEmail().toLowerCase();
  if (!email) return undefined;
  return employees.find((employee) => employee.email?.trim().toLowerCase() === email)?.id;
}

/** ID del actor: sesión + fallback por email en lista de empleados. */
export function getActorEmployeeId(
  employees?: Array<{ id: number; email?: string | null }>,
): number | undefined {
  return getManufacturingBatchActorEmployeeId() ?? (employees ? resolveEmployeeIdByEmail(employees) : undefined);
}

export function manufacturingBatchActorPayload(): {
  changedByEmployeeId?: number;
  changedByDisplayName?: string;
  clientUser?: { name?: string; email?: string };
} {
  const displayName = getManufacturingBatchDisplayName();
  const employeeId = getManufacturingBatchActorEmployeeId();
  const email = getCurrentUserEmail() || undefined;

  return {
    ...(employeeId != null ? { changedByEmployeeId: employeeId } : {}),
    ...(displayName ? { changedByDisplayName: displayName } : {}),
    ...(displayName || email
      ? {
          clientUser: {
            ...(displayName ? { name: displayName } : {}),
            ...(email ? { email } : {}),
          },
        }
      : {}),
  };
}
